module.exports = __webpack_public_path__ + "media/images/blank_image-3701f1a7.png";